import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import HeroBanner from '../components/HeroBanner';
import CTABanner from '../components/CTABanner';
import { paralegalServices, stats } from '../data';
import './ListingPage.css';

export default function ParalegalServices() {
  return (
    <>
      <HeroBanner
        title="Professional Paralegal Services You Can Trust"
        subtitle="Bridge Legal Services has experienced paralegals to handle your document review, contract management, and legal research needs to make your practice more efficient."
        breadcrumb="Paralegal Services"
        ctaText="Explore Services"
        ctaLink="#services"
      />

      {/* Stats */}
      <section className="stats-bar">
        <div className="container stats-bar__inner">
          {stats.map((stat) => (
            <div key={stat.label} className="stat-item">
              <span className="stat-value">{stat.value}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Services List */}
      <section className="listing-section" id="services">
        <div className="container">
          <div className="text-center">
            <span className="section-label">Specialized Paralegal Services</span>
            <h2 className="section-title">
              Providing comprehensive paralegal services with precision and professionalism
            </h2>
          </div>

          <div className="listing-items">
            {paralegalServices.map((svc, i) => (
              <div key={svc.slug} className={`listing-item ${i % 2 === 1 ? 'listing-item--reverse' : ''}`}>
                <div className="listing-item__content">
                  <h3>{svc.title}</h3>
                  <p>{svc.description}</p>
                  <Link to={`/${svc.slug}`} className="btn btn-outline">
                    Learn More <ArrowRight size={16} />
                  </Link>
                </div>
                <div className="listing-item__image">
                  <img src={svc.image} alt={svc.title} loading="lazy" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
